// src/pages/AdminPortal/TradingAccounts.jsx
import React, { useState, useEffect } from 'react';
import styles from './TradingAccounts.module.css';
// ✅ WORKING PATTERN:
const API_BASE_URL = "https://final-project-5ar7.onrender.com";


function TradingAccounts() {
  const [tradingAccounts, setTradingAccounts] = useState([]);
  const [accountRequests, setAccountRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('accounts');
const [volumeEditId, setVolumeEditId] = useState(null); // accountId being edited
const [volumeInput, setVolumeInput] = useState('');     // comma-separated input
  const fetchData = async () => {
    try {
      setLoading(true);
      const [accountsRes, requestsRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/admin/public/all-trading-accounts`),
        fetch(`${API_BASE_URL}/api/admin/public/all-account-requests`)
      ]);
      
      const accountsData = await accountsRes.json();
      const requestsData = await requestsRes.json();
      
      console.log('📊 Admin fetched accounts:', accountsData);
      console.log('📋 Admin fetched requests:', requestsData);
      
      setTradingAccounts(Array.isArray(accountsData) ? accountsData : []);
      setAccountRequests(Array.isArray(requestsData) ? requestsData : []);
    } catch (error) {
      console.error('❌ Failed to fetch admin data:', error);
      setTradingAccounts([]);
      setAccountRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleApproveAccount = async (accountId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/approve-trading-account/${accountId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (response.ok) {
        alert('✅ Trading account approved successfully!');
        fetchData(); // Refresh data
      } else {
        const error = await response.json();
        alert(`❌ Failed to approve account: ${error.message}`);
      }
    } catch (error) {
      console.error('❌ Error approving account:', error);
      alert('❌ Network error while approving account');
    }
  };

  const handleRejectAccount = async (accountId) => {
    const reason = prompt('Reason for rejection (optional):');
    
    if (confirm('Are you sure you want to reject this trading account?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/api/admin/public/reject-trading-account/${accountId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ reason })
        });
        
        if (response.ok) {
          alert('✅ Trading account rejected');
          fetchData();
        } else {
          const error = await response.json();
          alert(`❌ Failed to reject account: ${error.message}`);
        }
      } catch (error) {
        console.error('❌ Error rejecting account:', error);
        alert('❌ Network error while rejecting account');
      }
    }
  };
  const handleToggleAlgo = async (accountId, currentStatus) => {
  try {
    console.log('🤖 Toggling algo for:', accountId, 'current:', currentStatus);
    const res = await fetch(`${API_BASE_URL}/api/admin/public/toggle-algo/${accountId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ algoTradingActive: !currentStatus })
    });
    const data = await res.json();
    console.log('✅ Algo toggle response:', data);
    if (data.success) {
      setTradingAccounts(prev =>
        prev.map(a => a.accountId === accountId
          ? { ...a, algoTradingActive: data.algoTradingActive }
          : a
        )
      );
      alert(`🤖 Algo ${data.algoTradingActive ? 'STARTED ✅' : 'STOPPED ⛔'} for account ${accountId}`);
    } else {
      alert('❌ Failed: ' + data.message);
    }
  } catch (err) {
    console.error('❌ Algo toggle error:', err);
    alert('❌ Network error toggling algo');
  }
};
const handleUpdateMaxVolume = async (accountId) => {
  const val = parseFloat(parseFloat(volumeInput).toFixed(2));
  if (isNaN(val) || val < 0.01 || val > 200) {
    alert('❌ Enter a value between 0.01 and 200');
    return;
  }
  try {
    const res = await fetch(`${API_BASE_URL}/api/admin/public/update-max-volume/${accountId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ maxVolume: val })
    });
    const data = await res.json();
    if (data.success) {
      alert(`✅ Max volume set to ${data.maxVolume} for account ${accountId}`);
      setVolumeEditId(null);
      setVolumeInput('');
      fetchData();
    } else {
      alert('❌ ' + data.message);
    }
  } catch (err) {
    alert('❌ Network error');
  }
};
  const handleDeleteAccount = async (accountId, accountNum) => {
    const confirmation = prompt(
      `⚠️ DELETE TRADING ACCOUNT ⚠️\n\n` +
      `Account ID: ${accountNum}\n\n` +
      `This will PERMANENTLY delete this trading account.\n` +
      `The user will lose access to this account.\n\n` +
      `Type "DELETE" to confirm:`,
      ""
    );

    if (confirmation !== "DELETE") {
      alert('❌ Account deletion cancelled');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/delete-trading-account/${accountId}`, {
        method: 'DELETE'
      });
      
      if (response.ok) {
        alert('✅ Trading account permanently deleted!');
        fetchData(); // Refresh list
      } else {
        const error = await response.json();
        alert(`❌ Failed to delete account: ${error.message}`);
      }
    } catch (error) {
      console.error('❌ Error deleting account:', error);
      alert('❌ Network error while deleting account');
    }
  };
  

  const handleUpdateBalance = async (accountId, currentBalance) => {
    const newBalance = prompt('Enter new balance:', currentBalance.toString());
    
    if (newBalance !== null && !isNaN(parseFloat(newBalance))) {
      try {
        const response = await fetch(`${API_BASE_URL}/api/admin/public/update-trading-balance/${accountId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ balance: parseFloat(newBalance) })
        });
        
        if (response.ok) {
          alert('✅ Balance updated successfully!');
          fetchData();
        } else {
          const error = await response.json();
          alert(`❌ Failed to update balance: ${error.message}`);
        }
      } catch (error) {
        console.error('❌ Error updating balance:', error);
        alert('❌ Network error while updating balance');
      }
    }
  };

  const handleApproveRequest = async (requestId) => {
    const accountId = prompt('Enter Account ID (4 digits):');
    const mainPassword = prompt('Enter Main Password:');
    const investorPassword = prompt('Enter Investor Password:');
    const balance = prompt('Enter Initial Balance:', '0');
    
    if (accountId && mainPassword && investorPassword) {
      try {
        const response = await fetch(`${API_BASE_URL}/api/admin/public/approve-account-request/${requestId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customAccountId: accountId,
            mainPassword,
            investorPassword,
            balance: parseFloat(balance) || 0
          })
        });
        
        if (response.ok) {
          alert('✅ Account request approved and trading account created!');
          fetchData();
        } else {
          const error = await response.json();
          alert(`❌ Failed to approve request: ${error.message}`);
        }
      } catch (error) {
        console.error('❌ Error approving request:', error);
        alert('❌ Network error while approving request');
      }
    }
  };

  const handleRejectRequest = async (requestId) => {
    const adminNotes = prompt('Reason for rejection (optional):');
    
    if (confirm('Are you sure you want to reject this request?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/api/admin/public/reject-account-request/${requestId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ adminNotes })
        });
        
        if (response.ok) {
          alert('✅ Account request rejected');
          fetchData();
        } else {
          const error = await response.json();
          alert(`❌ Failed to reject request: ${error.message}`);
        }
      } catch (error) {
        console.error('❌ Error rejecting request:', error);
        alert('❌ Network error while rejecting request');
      }
    }
  };

  const pendingRequests = accountRequests.filter(req => req.status === 'pending');
  const pendingAccounts = tradingAccounts.filter(acc => acc.adminStatus === 'pending');
  const approvedAccounts = tradingAccounts.filter(acc => acc.adminStatus === 'approved');

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>🔄 Loading trading accounts...</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>📊 Trading Accounts Management</h1>
        <div className={styles.tabs}>
          <button 
            className={`${styles.tab} ${activeTab === 'accounts' ? styles.active : ''}`}
            onClick={() => setActiveTab('accounts')}
          >
            Trading Accounts ({tradingAccounts.length})
            {pendingAccounts.length > 0 && <span className={styles.pendingBadge}>{pendingAccounts.length} Pending</span>}
          </button>
          <button 
            className={`${styles.tab} ${activeTab === 'requests' ? styles.active : ''}`}
            onClick={() => setActiveTab('requests')}
          >
            Pending Requests ({pendingRequests.length})
            {pendingRequests.length > 0 && <span className={styles.badge}>{pendingRequests.length}</span>}
          </button>
        </div>
      </div>

      {activeTab === 'requests' && (
        <div className={styles.section}>
          <h2>📋 Account Requests</h2>
          
          {pendingRequests.length === 0 ? (
            <div className={styles.emptyState}>
              <p>No pending account requests.</p>
            </div>
          ) : (
            <div className={styles.requestsGrid}>
              {pendingRequests.map(request => (
                <div key={request._id} className={styles.requestCard}>
                  <div className={styles.requestHeader}>
                    <h3>{request.userId?.firstName} {request.userId?.lastName}</h3>
                    <span className={styles.requestDate}>
                      {new Date(request.createdAt).toLocaleDateString()}
                    </span>
                  </div>
                  
                  <div className={styles.requestDetails}>
                    <p><strong>Email:</strong> {request.userId?.email}</p>
                    <p><strong>Account Type:</strong> {request.accountType}</p>
                    <p><strong>Leverage:</strong> 1:{request.leverage}</p>
                    <p><strong>Experience:</strong> {request.tradingExperience}</p>
                    <p><strong>Est. Deposit:</strong> ${request.estimatedDeposit?.toLocaleString()}</p>
                    {request.comments && (
                      <p><strong>Comments:</strong> {request.comments}</p>
                    )}
                  </div>
                  
                  <div className={styles.requestActions}>
                    <button 
                      onClick={() => handleApproveRequest(request._id)}
                      className={styles.approveBtn}
                    >
                      ✅ Approve & Create Account
                    </button>
                    <button 
                      onClick={() => handleRejectRequest(request._id)}
                      className={styles.rejectBtn}
                    >
                      ❌ Reject
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {activeTab === 'accounts' && (
        <div className={styles.section}>
          <h2>All Trading Accounts ({tradingAccounts.length})</h2>
          
          {tradingAccounts.length === 0 ? (
            <div className={styles.emptyState}>
              <p>No trading accounts found.</p>
            </div>
          ) : (
            <div className={styles.tableWrapper}>
              <table className={styles.accountsTable}>
                <thead>
                  <tr>
                    <th>Account ID</th>
                    <th>User</th>
                    <th>Email</th>
                    <th>Group</th>
                    <th>Balance</th>
                    <th>Equity</th>
                    <th>Leverage</th>
                    <th>Server</th>
                    <th>Admin Status</th>
                    <th>Created</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {tradingAccounts.map(account => (
                    <tr key={account._id}>
                      <td><strong>{account.accountId}</strong></td>
                      <td>
                        {account.userId?.firstName} {account.userId?.lastName}
                      </td>
                      <td>{account.userId?.email}</td>
                      <td>
                        <span className={styles.groupBadge}>
                          {account.group}
                        </span>
                      </td>
                      <td>
                        <span 
                          className={styles.balance}
                          onClick={() => handleUpdateBalance(account.accountId, account.balance)}
                          title="Click to update balance"
                        >
                          ${account.balance}
                        </span>
                      </td>
                      <td>${account.equity}</td>
                      <td>
  <span
    style={{ cursor: 'pointer', textDecoration: 'underline', color: '#f59e0b' }}
    onClick={() => handleEditTradingAccount(account._id, 'leverage', account.leverage)}
    title="Click to edit leverage"
  >
    1:{account.leverage}
  </span>
</td>
                      <td>{account.server}</td>
                      <td>
                        <span className={`${styles.statusBadge} ${styles[account.adminStatus || 'pending']}`}>
                          {account.adminStatus === 'pending' && '⏳ Pending'}
                          {account.adminStatus === 'approved' && '✅ Approved'}
                          {account.adminStatus === 'rejected' && '❌ Rejected'}
                          {!account.adminStatus && '⏳ Pending'}
                        </span>
                      </td>
                      <td>{new Date(account.createdAt).toLocaleDateString()}</td>
                      <td>
  <div className={styles.actionButtons}>
    {(account.adminStatus === 'pending' || !account.adminStatus) && (
      <>
        <button 
          onClick={() => handleApproveAccount(account._id)}
          className={styles.approveBtn}
          title="Approve Account"
        >
          ✅
        </button>
        <button 
          onClick={() => handleRejectAccount(account._id)}
          className={styles.rejectBtn}
          title="Reject Account"
        >
          ❌
        </button>
      </>
    )}
    <button 
      onClick={() => alert(`Account Details:\n\nAccount ID: ${account.accountId}\nMain Password: ${account.mainPassword}\nInvestor Password: ${account.investorPassword}\nServer: ${account.server}\nGroup: ${account.group}\nLeverage: 1:${account.leverage}`)}
      className={styles.viewBtn}
      title="View Details"
    >
      👁️
    </button>
    {/* ✅ NEW: Delete Trading Account Button */}
    <button 
      onClick={() => handleDeleteAccount(account._id, account.accountId)}
      className={styles.deleteBtn}
      title="Delete Account Permanently"
    >
      🗑️
    </button>
  <button
  onClick={() => handleToggleAlgo(account.accountId, account.algoTradingActive)}
  title={account.algoTradingActive ? 'Stop Algo Trading' : 'Start Algo Trading'}
  style={{
    background: account.algoTradingActive ? '#dcfce7' : '#f1f5f9',
    border: `2px solid ${account.algoTradingActive ? '#22c55e' : '#cbd5e1'}`,
    borderRadius: '6px',
    width: '32px', height: '32px',
    padding: '4px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
    boxShadow: account.algoTradingActive ? '0 0 6px rgba(34,197,94,0.5)' : 'none'
  }}
>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="7" y="11" width="10" height="9" rx="2"
      fill={account.algoTradingActive ? '#16a34a' : '#94a3b8'}/>
    <rect x="9" y="6" width="6" height="6" rx="1"
      fill={account.algoTradingActive ? '#22c55e' : '#cbd5e1'}/>
    <circle cx="10" cy="9" r="1.2"
      fill={account.algoTradingActive ? '#fff' : '#e2e8f0'}/>
    <circle cx="14" cy="9" r="1.2"
      fill={account.algoTradingActive ? '#fff' : '#e2e8f0'}/>
    <rect x="11" y="2" width="2" height="4" rx="1"
      fill={account.algoTradingActive ? '#22c55e' : '#94a3b8'}/>
    <rect x="4" y="14" width="3" height="4" rx="1"
      fill={account.algoTradingActive ? '#16a34a' : '#94a3b8'}/>
    <rect x="17" y="14" width="3" height="4" rx="1"
      fill={account.algoTradingActive ? '#16a34a' : '#94a3b8'}/>
    <rect x="9.5" y="15" width="5" height="2" rx="1"
      fill={account.algoTradingActive ? '#bbf7d0' : '#e2e8f0'}/>
  </svg>
</button>
{/* ✅ Volume Sizes Editor */}
{volumeEditId === account.accountId ? (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '4px', minWidth: '140px' }}>
    <label style={{ fontSize: '10px', color: '#6b7280', margin: 0 }}>Max Volume (0.01–200)</label>
    <input
      type="number"
      min="0.01"
      max="200"
      step="0.01"
      value={volumeInput}
      onChange={e => setVolumeInput(e.target.value)}
      placeholder="e.g. 50.00"
      style={{ padding: '4px 6px', fontSize: '12px', border: '1px solid #3b82f6', borderRadius: '4px', width: '100%' }}
      autoFocus
    />
    <div style={{ display: 'flex', gap: '4px' }}>
      <button
        onClick={() => handleUpdateMaxVolume(account.accountId)}
        style={{ flex: 1, background: '#10b981', color: 'white', border: 'none', padding: '4px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}
      >
        ✅ Save
      </button>
      <button
        onClick={() => { setVolumeEditId(null); setVolumeInput(''); }}
        style={{ flex: 1, background: '#6b7280', color: 'white', border: 'none', padding: '4px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}
      >
        ✕
      </button>
    </div>
    <span style={{ fontSize: '10px', color: '#9ca3af' }}>
      Current: {(account.maxVolume || 100).toFixed(2)}
    </span>
  </div>
) : (
  <button
    onClick={() => {
      setVolumeEditId(account.accountId);
      setVolumeInput((account.maxVolume || 100).toFixed(2));
    }}
    title={`Edit Max Volume (current: ${(account.maxVolume || 100).toFixed(2)})`}
    style={{
      background: '#eff6ff', border: '1px solid #93c5fd',
      borderRadius: '6px', width: '32px', height: '32px',
      cursor: 'pointer', fontSize: '14px',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
    }}
  >
    📊
  </button>
)}
  </div>
</td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default TradingAccounts;
